// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Ly_9","actionsCol":"EnrolledClinics_actionsCol__1L4Kr"};